import typography from '@/theme/typography';
import styled from 'styled-components';
import {StyledSublistProps} from './typings';
import {sizePx} from '@/theme/helpers/size';

export const StyledSublist = styled.div<StyledSublistProps>`
  margin-left: 28px;
  margin-top: -8px;
  display: ${(props) => (props.$visible ? 'block' : 'none')};

  & & {
    margin: ${sizePx(1)} 0;
  }
`;

export const StyledGroupName = styled.p`
  ${typography.Body2}
  text-transform: capitalize;
  margin-left: ${sizePx(1)};
`;
